'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoSizer = exports.default = undefined;

var _AutoSizer2 = require('./AutoSizer');

var _AutoSizer3 = _interopRequireDefault(_AutoSizer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AutoSizer3.default;
exports.AutoSizer = _AutoSizer3.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-virtualized/dist/commonjs/AutoSizer/index.js
 ** module id = ./node_modules/react-virtualized/dist/commonjs/AutoSizer/index.js
 ** module chunks = 1
 **/